/**
 * How long before a call back the visitor still has to confirm it. The callback endpoint rejects
 * an instant that is no longer in the future, so a booking sent this close to the slot would come
 * back as an error.
 *
 * Both flows read this one value: the picker stops offering a slot this close to starting and
 * counts down to the deadline, and "call now" books exactly this far ahead so the request has the
 * same margin to reach the endpoint.
 */
export const CONFIRM_LEAD_MS = 2 * 60 * 1000;

/** How often the picker's confirmation step redraws its countdown. */
export const COUNTDOWN_REFRESH_MS = 1_000;
